// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"50b3b9b3","98":"d214e38e","471":"d1475402"}[chunkId] + ".chunk.js";
};